import { useLocation } from 'react-router-dom';
import { AuthShell } from './Login';
import { Alert } from '../components/ui';

export default function CheckEmail() {
  const state = (useLocation().state ?? {}) as { email?: string };
  return (
    <AuthShell title="Check your inbox">
      <div className="space-y-4 text-center">
        <div className="text-5xl">📬</div>
        <p className="text-sm text-slate-600">
          If an account exists for{' '}
          <span className="font-semibold text-slate-900">{state.email ?? 'that address'}</span>, a sign-in link is on
          its way. Click it to finish signing in.
        </p>
        <Alert kind="info">The link expires in 15 minutes and can be used once.</Alert>
        <p className="text-xs text-slate-400">You can close this tab — the link opens a fresh session.</p>
      </div>
    </AuthShell>
  );
}
